<template>
  <div id="main-product-detail" class="main-product-detail">
    <VTabsWithAnimationMTS :selected-tab.sync="nameSelectedTab">
      <VTabMTS
        v-for="(section, idxSection) in sectionsList"
        :key="idxSection"
        :name="section.name"
        :selected="idxSection === 0"
      >
        <VAccordionWithProgressBarMTS
          :items="section.productsList"
          :with-icon="{
            name: 'mts/icon-mts--plus',
            width: 16,
            height: 16,
            fill: '#8D969F',
          }"
          with-media
          with-progress-bar
          auto-play
        >
          <template #button>
            <div class="main-product-detail__btn-wrapper">
              <span class="main-product-detail__btn_description"
                >Позвоним и&nbsp;согласуем время для&nbsp;демонстрации</span
              >
              <VButtonMTSV2
                class="main-product-detail__btn --violet-gradient --m"
                @click="openPopup"
                ><span>Записаться на&nbsp;демо</span></VButtonMTSV2
              >
            </div>
          </template>
        </VAccordionWithProgressBarMTS>
      </VTabMTS>
    </VTabsWithAnimationMTS>
    <Popup v-if="isOpenPopup" :is-closable="true" @close-popup="closePopup">
      <VCardMTS class="--l --white task-education-devices__card-form">
        <MTSApplicationUniversalForm
          :form-name="sectionsList[idxSelectedSection].form.id"
          :form-id-value="sectionsList[idxSelectedSection].form.idValue"
          :form-title="'Оставьте заявку'"
          :form-description="'Позвоним и согласуем время для демонстрации'"
          :form-btn-text="'Оставить заявку'"
          :form-btn-color="'--violet'"
        />
      </VCardMTS>
    </Popup>
  </div>
</template>
<script>
import MainProductsBlockMixin from '~/components/Desktop/Main/mixins/MainProductsBlockMixin'
import VTabsWithAnimationMTS from '~/components/Common/MTS/VTabsWithAnimationMTS.vue'
import VAccordionWithProgressBarMTS from '~/components/Common/MTS/VAccordionWithProgressBarMTS.vue'
import VTabMTS from '~/components/Common/MTS/VTabMTS.vue'
import VButtonMTSV2 from '~/components/Common/MTS/VButtonMTSV2.vue'
import VCardMTS from '~/components/Common/MTS/VCardMTS.vue'
import Popup from '~/components/Common/Popup/Popup.vue'
import MTSApplicationUniversalForm from '~/components/Common/Form/MTSApplicationUniversalForm.vue'

export default {
  name: 'MainProductsBlockDesktop',
  props: {
    nameSelectedSection: {
      type: String,
      default: '',
    },
  },
  components: {
    VTabsWithAnimationMTS,
    VTabMTS,
    VAccordionWithProgressBarMTS,
    Popup,
    MTSApplicationUniversalForm,
    VButtonMTSV2,
    VCardMTS,
  },
  mixins: [MainProductsBlockMixin],
}
</script>
<style lang="scss" scoped>
.main-product-detail {
  padding-top: 32px;
  &__btn {
    justify-content: center;
    max-width: 260px;
    @include screen-down('lg') {
      margin: 0 auto;
    }

    &-wrapper {
      margin-top: auto;
      margin-bottom: 0;
      @include screen-down('lg') {
        text-align: center;
        margin: 64px auto 0;
        max-width: 257px;
      }
    }
    &_description {
      display: inline-block;
      color: $color-gray-1;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }
}
</style>
